import { validations } from '@/assets';
import { validationError, validationMessage } from '@/helpers';
import { validateMobilePhoneNumber } from '@/services';

import { type InitialApplication } from './useApplication';

export type ContactInfoFields = {
  initialEmail: string;
  initialPhone: string;
  saveContactInfo: (email: string, phoneNumber: string) => Promise<void>;
  validateEmail: (email: string) => string;
  validatePhone: (
    phoneNumber: string,
    callingCode: number,
    number: number,
  ) => Promise<string>;
};
export const contactInfo = ({
  application,
  country,
  save,
}: InitialApplication): ContactInfoFields => {
  const initialEmail = application.email || '';
  const initialPhone = application.phoneNumber || '';

  const saveContactInfo = async (email: string, phoneNumber: string) => {
    return save({ email, phoneNumber });
  };

  const validateEmail = (email: string) =>
    validationMessage(
      true,
      validations[country].email,
      validationError(validations[country].email, email),
    );

  const validatePhone = async (
    phoneNumber: string,
    callingCode: number,
    number: number,
  ) => {
    const errorMessage = validationMessage(
      true,
      validations[country].phoneNumber,
      validationError(validations[country].phoneNumber, phoneNumber),
    );

    if (errorMessage) return errorMessage;

    try {
      await validateMobilePhoneNumber(callingCode, number);
    } catch {
      return 'category.contact-info.phone.validation-error_format';
    }

    return '';
  };

  return {
    initialEmail,
    initialPhone,
    saveContactInfo,
    validateEmail,
    validatePhone,
  };
};
